import { render, staticRenderFns } from "./waitFor.vue?vue&type=template&id=a0b0a0c0&scoped=true&"
import script from "./waitFor.vue?vue&type=script&lang=js&"
export * from "./waitFor.vue?vue&type=script&lang=js&"
import style0 from "./waitFor.vue?vue&type=style&index=0&id=a0b0a0c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b0a0c0",
  null
  
)

export default component.exports